<template>
  <div class="login"
   v-loading="showLoad"
   element-loading-text="拼命加载中"
   element-loading-spinner="el-icon-loading">
   <!-- 返回旧版渔管理 -->
    <!-- <div class="login-icon-1" @click="intoOldVersion">
      <img src="../../../public/img/icon_back_jiuban.png" alt="" >
      &nbsp;
      <span>返回旧版渔管理</span>
    </div> -->
    <!-- 登陆图标 -->
    <div class="login-icon" >
      <img src="../../../public/img/nxinlogo.png" alt="">
    </div>
    <!-- 嵌套登陆窗 -->
    <iframe :src="url" frameborder="0" class="login-iframe" scrolling="no" @load="showLoad=false"></iframe>
  </div>
</template>

<script>
import Url from "../../service/base-url";
import qs from "query-string";
export default {
  name: "Login",
  data() {
    return {
      showLoad: true
    };
  },
  mounted() {},
  computed: {
    url() {
      let query = {
        returnUrl: `${window.location.origin}/logincallback`,
        loginUrl: Url.casLogin
      };
      // console.log(`${Url.base}/api/account/login?${qs.stringify(query)}`);

      return `${Url.base}/api/account/login?${qs.stringify(query)}`;
    }
  },
  methods: {
    intoOldVersion() {
      window.open("http://ylwgl2.nxin.com/Main");
    }
  }
};
</script>

<style lang="stylus" scoped>
.login
  height 100%
  background-color #F2F2F2
  display flex
  flex-direction column
  overflow hidden

  .login-icon-1
    cursor: pointer;
    display: flex;
    flex-direction: row;
    float:right;
    margin:30px 60px 0 0 ;
    z-index:9999;
    span 
      display block
      margin-right:-20px;
      font-size 20px;
      color:#2189ff;
    img   
      width:24px;
      height:24px;
      display block
      margin-top:4px;
                
       
  .login-icon
    flex-shrink 0
    text-align center
    padding 20px 0 12px
    background-color #fff

    >img
      width 110px

  .login-iframe
    flex 1
    width 100%
    min-height 0
    border none
</style>
